import React, { useState } from "react";
import {
  Form,
  Input,
  Button,
  Space,
  Table,
  Menu,
  InputNumber,
  Image,
} from "antd";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";

export default function Feed() {
  const navigate = useNavigate();
  //当前tab
  const location = useLocation();
  const pathname = location.pathname.split("/")[2] || "influencer";
  const [current, setCurrent] = useState(pathname);
  //tab名称
  const items = [
    {
      label: "达人排序",
      key: "influencer",
    },
    {
      label: "明星排序",
      key: "star",
    },
  ];
  const onClick = (e) => {
    setCurrent(e.key);
    navigate(e.key);
  };

  //表头
  const columns = [
    {
      title: "排序",
      dataIndex: "order",
      key: "order",
      render: (_, record) => (
        <>
          {isChanging.id === record.id ? (
            <Form.Item
              name="order"
              initialValue={record.order}
              style={{ margin: 0 }}
            >
              <InputNumber min="1" autoFocus />
            </Form.Item>
          ) : (
            <>{record.order}</>
          )}
        </>
      ),
    },
    {
      title: "名人昵称",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "名人ID",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "头像",
      dataIndex: "img",
      key: "img",
      render: (img) => <Image width={100} src={img} />,
    },
    {
      title: "月销",
      dataIndex: "monthlySales",
      key: "monthlySales",
    },
    {
      title: "评分",
      dataIndex: "rate",
      key: "rate",
    },
    {
      title: "操作",
      dataIndex: "opeartion",
      key: "opeartion",
      render: (_, record) => (
        <div>
          <Space>
            {isChanging.id === record.id ? (
              <>
                <Button type="primary" htmlType="submit">
                  确认
                </Button>
                <Button onClick={() => setIsChanging(false)}>取消</Button>
              </>
            ) : (
              <>
                <Button type="primary" onClick={() => handleIsChanging(record)}>
                  修改
                </Button>
                <Button>恢复默认</Button>
              </>
            )}
          </Space>
        </div>
      ),
    },
  ];
  //全部数据
  const data = [
    {
      key: "1",
      order: 1,
      name: "马牛逼",
      id: "123456",
      img: "https://s2.loli.net/2023/07/25/fjouqVLAlTn2s58.png",
      monthlySales: 888,
      rate: 4.9,
    },
    {
      key: "2",
      order: 2,
      name: "迪迦",
      id: "10086",
      img: "https://s2.loli.net/2023/07/25/1daCqmZGQNUzoJ8.png",
      monthlySales: 999,
      rate: 5.0,
    },
  ];
  //展示的数据
  const [showData, setShowData] = useState(data);
  //设置进入修改的数据
  const [isChanging, setIsChanging] = useState({});
  //点击修改按钮
  const handleIsChanging = (record) => {
    setIsChanging(record);
    console.log("点击修改", isChanging);
  };
  //点击确认按钮
  const handleConfirm = (value) => {
    //当数值变化时，提交数据
    value.order !== isChanging.order &&
      //提交数据后关闭输入框
      // console.log("提交");
      setIsChanging(false);
    console.log("点击确认", isChanging.id);
  };

  //搜索名人
  const search = (value) => {
    value.name || value.id
      ? setShowData(
          data.filter(
            (item) => item.name === value.name || item.id === value.id
          )
        )
      : setShowData(data);
  };
  //表单提交失败
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  //tab内容
  const FeedContent = () => {
    return (
      <div style={{ marginLeft: 20, marginRight: 20 }}>
        <p>未添加排序的名人按照评分排序</p>
        <Form name="search" onFinish={search} onFinishFailed={onFinishFailed}>
          <Space style={{ marginBottom: 20 }}>
            <Form.Item label="名人昵称" name="name" style={{ margin: 0 }}>
              <Input />
            </Form.Item>
            <Form.Item label="名人ID" name="id" style={{ margin: 0 }}>
              <Input />
            </Form.Item>
            <Button type="primary" htmlType="submit">
              搜索
            </Button>
          </Space>
        </Form>
        <Form
          name="change"
          onFinish={handleConfirm}
          onFinishFailed={onFinishFailed}
        >
          <Table
            columns={columns}
            dataSource={showData}
            pagination={{ pageSize: 20 }}
            scroll={{ y: window.innerHeight - 300 }}
          />
        </Form>
      </div>
    );
  };

  return (
    <div>
      <Menu
        onClick={onClick}
        selectedKeys={[current]}
        mode="horizontal"
        items={items}
      />
      <Routes>
        <Route path="/" element={<Navigate to="/feed/influencer" />} />
        <Route path="/influencer" element={<FeedContent />} />
        <Route path="/star" element={<FeedContent />} />
      </Routes>
    </div>
  );
}
